// Enums.
import ciap from '@/enums/geral/ciap'
import cid from '@/enums/geral/cid'

export default {
    computed: {
        ciapsGravidez() {
            return {
                normal: [
                    this.enums.ciap.GRAVIDEZ,
                ],
                altoRisco: [
                    this.enums.ciap.DIABETES_GESTACIONAL,
                    this.enums.ciap.GRAVIDEZ_DE_ALTO_RISCO,
                    this.enums.ciap.GRAVIDEZ_ECTOPICA,
                    this.enums.ciap.GRAVIDEZ_NAO_DESEJADA,
                    this.enums.ciap.INFECCOES_QUE_COMPLICAM_A_GRAVIDEZ,
                    this.enums.ciap.TOXEMIA_GRAVIDICA_DHEG,
                ],
                desfecho: [
                    this.enums.ciap.ABORTO_ESPONTANEO,
                    this.enums.ciap.ABORTO_PROVOCADO,
                    this.enums.ciap.PARTO_SEM_COMPLICACOES_DE_NASCIDO_VIVO,
                    this.enums.ciap.PARTO_SEM_COMPLICACOES_DE_NATIMORTO,
                    this.enums.ciap.PARTO_COM_COMPLICACOES_DE_NASCIDO_VIVO,
                    this.enums.ciap.PARTO_COM_COMPLICACOES_DE_NATIMORTO,
                ],
            }
        },
        cidsGravidez() {
            return {
                normal: [
                    this.enums.cid.SUPERVISAO_DE_GRAVIDEZ_NORMAL,
                    this.enums.cid.SUPERVISAO_DE_GRAVIDEZ_NORMAL_NAO_ESPECIFICADA,
                    this.enums.cid.SUPERVISAO_DE_OUTRA_GRAVIDEZ_NORMAL,
                    this.enums.cid.SUPERVISAO_DE_PRIMEIRA_GRAVIDEZ_NORMAL,
                ],
                altoRisco: [
                    this.enums.cid.SUPERVISAO_DE_GRAVIDEZ_DE_ALTO_RISCO,
                    this.enums.cid.SUPERVISAO_DE_GRAVIDEZ_COM_HISTORIA_DE_ESTERILIDADE,
                    this.enums.cid.SUPERVISAO_DE_GRAVIDEZ_COM_HISTORIA_DE_ABORTO,
                    this.enums.cid.SUPERVISAO_DE_GRAVIDEZ_COM_OUTROS_ANTECEDENTES_DE_PROCRIACAO_PROBLEMATICA,
                    this.enums.cid.SUPERVISAO_DE_GRAVIDEZ_COM_HISTORIA_DE_ASSISTENCIA_PRE_NATAL_INSUFICIENTE,
                    this.enums.cid.SUPERVISAO_DE_GRAVIDEZ_COM_GRANDE_MULTIPARIDADE,
                    this.enums.cid.SUPERVISAO_DE_PRIMIGESTA_IDOSA,
                    this.enums.cid.SUPERVISAO_DE_PRIMIGESTA_MUITO_JOVEM,
                    this.enums.cid.SUPERVISAO_DE_GRAVIDEZ_DE_ALTO_RISCO_DEVIDO_A_PROBLEMAS_SOCIAIS,
                    this.enums.cid.SUPERVISAO_DE_OUTRAS_GRAVIDEZES_DE_ALTO_RISCO,
                    this.enums.cid.SUPERVISAO_NAO_ESPECIFICADA_DE_GRAVIDEZ_DE_ALTO_RISCO,
                ],
                desfecho: [
                    this.enums.cid.ABORTO_ESPONTANEO,
                    this.enums.cid.ABORTO_NAO_ESPECIFICADO,
                    this.enums.cid.ABORTO_POR_RAZOES_MEDICAS_E_LEGAIS,
                    this.enums.cid.ANORMALIDADES_DA_CONTRACAO_UTERINA,
                    this.enums.cid.ASSISTENCIA_E_EXAME_POS_NATAL,
                    this.enums.cid.CHOQUE_DURANTE_OU_SUBSEQUENTE_AO_TRABALHO_DE_PARTO_E_O_PARTO,
                    this.enums.cid.COMPLICACOES_DO_TRABALHO_DE_PARTO_E_DO_PARTO_NAO_ESPECIFICADAS,
                    this.enums.cid.DEMORA_DO_PARTO_APOS_RUPTURA_ARTIFICIAL_DAS_MEMBRANAS,
                    this.enums.cid.DEMORA_DO_PARTO_APOS_RUPTURA_ESPONTANEA_OU_NAO_ESPECIFICADA_DAS_MEMBRANAS,
                    this.enums.cid.DESCOLAMENTO_PREMATURO_DA_PLACENTA_ABRUPTIO_PLACENTAE,
                    this.enums.cid.EXTRACAO_MENSTRUAL,
                    this.enums.cid.FALHA_NA_INDUCAO_DO_TRABALHO_DE_PARTO,
                    this.enums.cid.LACERACAO_DO_PERINEO_DURANTE_O_PARTO,
                    this.enums.cid.NASCIDOS_VIVOS_SEGUNDO_O_LOCAL_DE_NASCIMENTO,
                    this.enums.cid.NASCIMENTO_GEMELAR_GEMEOS_AMBOS_NATIVIVOS_NADO_VIVOS,
                    this.enums.cid.NASCIMENTO_GEMELAR_GEMEOS_NATIMORTOS_FETO_MORTOS,
                    this.enums.cid.NASCIMENTO_GEMELAR_UM_DOS_GEMEOS_NATIVIVO_NADO_VIVO_O_OUTRO_NATIMORTO_FETO_MORTO,
                    this.enums.cid.NASCIMENTO_NAO_ESPECIFICADO,
                    this.enums.cid.NASCIMENTO_UNICO_NATIMORTO_FETO_MORTO,
                    this.enums.cid.NASCIMENTO_UNICO_NATIVIVO_NADO_VIVO,
                    this.enums.cid.OBSTRUCAO_DO_TRABALHO_DE_PARTO_DEVIDA_A_ANORMALIDADE_PELVICA_DA_MAE,
                    this.enums.cid.OBSTRUCAO_DO_TRABALHO_DE_PARTO_DEVIDA_A_MA_POSICAO_OU_MA_APRESENTACAO_DO_FETO,
                    this.enums.cid.OUTRAS_COMPLICACOES_DE_PROCEDIMENTOS_OU_DE_CIRURGIA_OBSTETRICA,
                    this.enums.cid.OUTRAS_COMPLICACOES_ESPECIFICADAS_DO_TRABALHO_DE_PARTO_E_DO_PARTO,
                    this.enums.cid.OUTRAS_FORMAS_DE_OBSTRUCAO_DO_TRABALHO_DE_PARTO,
                    this.enums.cid.OUTROS_NASCIMENTOS_MULTIPLOS_ALGUNS_NATIVIVOS_NADO_VIVOS,
                    this.enums.cid.OUTROS_NASCIMENTOS_MULTIPLOS_TODOS_NATIMORTOS_FETO_MORTOS,
                    this.enums.cid.OUTROS_NASCIMENTOS_MULTIPLOS_TODOS_NATIVIVOS_NADO_VIVOS,
                    this.enums.cid.OUTROS_PRODUTOS_ANORMAIS_DA_CONCEPCAO,
                    this.enums.cid.OUTROS_TIPOS_DE_ABORTO,
                    this.enums.cid.OUTROS_TIPOS_DE_PARTO_UNICO_ASSISTIDO,
                    this.enums.cid.OUTROS_TRAUMATISMOS_OBSTETRICOS,
                    this.enums.cid.PARTO_MULTIPLO,
                    this.enums.cid.PARTO_UNICO_ESPONTANEO,
                    this.enums.cid.PARTO_UNICO_POR_CESARIANA,
                    this.enums.cid.PARTO_UNICO_POR_FORCEPS_OU_VACUO_EXTRATOR,
                    this.enums.cid.PARTO_VAGINAL_SUBSEQUENTE_A_CESARIANA_ANTERIOR,
                    this.enums.cid.RETENCAO_DA_PLACENTA_E_DAS_MEMBRANAS_SEM_HEMORRAGIAS,
                    this.enums.cid.RUPTURA_PREMATURA_DE_MEMBRANAS,
                    this.enums.cid.SOFRIMENTO_MATERNO_DURANTE_O_TRABALHO_DE_PARTO_E_O_PARTO,
                    this.enums.cid.TRABALHO_DE_PARTO_E_PARTO_COMPLICADOS_POR_ANORMALIDADE_DO_CORDAO_UMBILICAL,
                    this.enums.cid.TRABALHO_DE_PARTO_E_PARTO_COMPLICADOS_POR_HEMORRAGIA_INTRAPARTO_NAO_CLASSIFICADOS_EM_OUTRA_PARTE,
                    this.enums.cid.TRABALHO_DE_PARTO_E_PARTO_COMPLICADOS_POR_SOFRIMENTO_FETAL,
                    this.enums.cid.TRABALHO_DE_PARTO_PRE_TERMO,
                    this.enums.cid.TRABALHO_DE_PARTO_PROLONGADO,
                ],
            }
        },
    },
    data: () => ({
        enums: {ciap, cid},
    }),
    methods: {
        isGravidezNormal(problemaCondicao) {
            let isCiapGravidezNormal = false
            let isCidGravidezNormal = false

            if (problemaCondicao.ciap) {
                isCiapGravidezNormal = this.ciapsGravidez.normal.includes(problemaCondicao.ciap.codigo)
            }

            if (problemaCondicao.cid) {
                isCidGravidezNormal = this.cidsGravidez.normal.includes(problemaCondicao.cid.codigo)
            }

            return isCiapGravidezNormal || isCidGravidezNormal
        },
        isGravidezAltoRisco(problemaCondicao) {
            let isCiapGravidezAltoRisco = false
            let isCidGravidezAltoRisco = false

            if (problemaCondicao.ciap) {
                isCiapGravidezAltoRisco = this.ciapsGravidez.altoRisco.includes(problemaCondicao.ciap.codigo)
            }

            if (problemaCondicao.cid) {
                isCidGravidezAltoRisco = this.cidsGravidez.altoRisco.includes(problemaCondicao.cid.codigo)
            }

            return isCiapGravidezAltoRisco || isCidGravidezAltoRisco
        },
        isDesfechoGravidez(problemaCondicao) {
            let isCiapDesfechoGravidez = false
            let isCidDesfechoGravidez = false

            if (problemaCondicao.ciap) {
                isCiapDesfechoGravidez = this.ciapsGravidez.desfecho.includes(problemaCondicao.ciap.codigo)
            }

            if (problemaCondicao.cid) {
                isCidDesfechoGravidez = this.cidsGravidez.desfecho.includes(problemaCondicao.cid.codigo)
            }

            return isCiapDesfechoGravidez || isCidDesfechoGravidez
        },
    },
}